import { render, staticRenderFns } from "./comerr.vue?vue&type=template&id=12a11803&scoped=true&"
import script from "./comerr.vue?vue&type=script&lang=js&"
export * from "./comerr.vue?vue&type=script&lang=js&"
import style0 from "./comerr.vue?vue&type=style&index=0&id=12a11803&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a11803",
  null
  
)

export default component.exports